import { Action, createReducer, on } from '@ngrx/store';
import * as LinksStoreActions from './links-store.actions';
import { Link } from '../models/link';

export const linksStoreFeatureKey = 'linksStore';

export interface State {
    links: Link[];
    linksLoaded: boolean;
}

export const initialState: State = {
    links: [],
    linksLoaded: false,
};

export const reducer = createReducer(
    initialState,

    on(LinksStoreActions.loadLinks, (state) => state),
    on(LinksStoreActions.loadLinksSuccess, (state, action): State => {
        return {
            ...state,
            links: action.data,
            linksLoaded: true,
        };
    })
);
